import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class NacoGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = localStorage.getItem('token');
        const role = localStorage.getItem('roleId');
        if (currentUser && role == '5') {
            return true;
        }
        this.router.navigate(['user-login']);
        return false;
    }

}
